import { AnyAppEvent, AppEvent } from "../appEvent.types";

const eventName = "new-equipment-request" as const;

export type NewEquipmentRequestEventData = {
  eventId: string;
};
export type NewEquipmentRequestEvent = AppEvent<
  typeof eventName,
  NewEquipmentRequestEventData
>;

export const isNewEquipmentRequestEvent = (
  event: AnyAppEvent
): event is NewEquipmentRequestEvent => event.name === eventName;

export { eventName as newEquipmentRequest };
